import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      placeholder: '请选择直播间',
      rules: {required: true, message: '直播间是必传的', trigger: 'blur'}
    },
    {
      field: 'timeLong',
      type: 'input',
      label: '观看时长',
      placeholder: '请输入观看时长（单位：分钟）',
      rules: {required: true, message: '观看时长是必传的', trigger: 'blur'}
    },
    {
      field: 'timeSlot',
      type: 'timePicker',
      label: '时间范围',
      rules: {required: true, message: '时间范围是必传的', trigger: 'blur'}
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
